module.exports = __webpack_public_path__ + "fonts/drukcyr-medium.0cd1629c.ttf";